import axios from 'axios'

const eventbrite = axios.create({
  baseURL: 'https://www.eventbriteapi.com/v3/',
  timeout: 1000,
  headers: {
    'Authorization': 'Bearer RVBZOM7GGDHRRBXJKBGM',
    'Content-Type': 'application/json'
  }
});

export default eventbrite